// import { useEffect, useState } from "react";
import KenSelect from '../../../../GlobalComponents/KenSelect';
import { Box, Button, Divider, InputAdornment, Theme, Grid, Typography, Select, MenuItem, SelectChangeEvent, TextField, IconButton } from '@mui/material';
import KenInput from '../../../../GlobalComponents/KenInput';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MicIcon from '@mui/icons-material/Mic';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { SearchBarProps, searchBarData } from '../../../../interfaces/Common';
import { makeStyles } from '@mui/styles';
import { useStyles as JobStyles } from '../../styles';
import { useEffect, useState } from 'react';
import KenColors from '../../../../Helpers/Themes/kenColors';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const useStyles = makeStyles((theme: Theme) => ({
  searchContainer: {
    display: 'flex',
    gap: '10px',
    // margin: '0px 20px 0px 0px',
    border: '1px solid #B2B3B7',
    alignItems: 'center',
    borderRadius: '9px',
  },
}));

const SearchBar: React.FunctionComponent<SearchBarProps> = ({ handleFilter, dropDownData, handleDropDownChange, handleSearchChange, searchBarData }) => {
  const classes = useStyles();
  const jobClasses = JobStyles();
  const [data, setData] = useState<searchBarData>({ dropDown: '', input: '' });

  // const [audio, setAudio] = useState<boolean>(false);
  // const [audioData, setAudioData] = useState<any>([]);

  // const getAudioTracks = () => {
  //   if (audio) {
  //     setAudio(false);
  //   } else {
  //     setAudio(true);
  //   }
  // };

  // useEffect(() => {
  //   let mediaRecorder: MediaRecorder;
  //   const handleDataAvailable = (ev: BlobEvent) => {
  //     setAudioData((prevData: any) => [...prevData, ev.data]);
  //   };
  //   const handleStop = () => {
  //     let buff = new Blob(audioData, { type: "audio/ogg" });
  //     console.log(buff);
  //     console.log(buff.size);
  //   };
  //   const initRecorder = (stream: MediaStream) => {
  //     mediaRecorder = new MediaRecorder(stream);
  //     if (audio) {
  //       mediaRecorder.start();
  //     }
  //     mediaRecorder.ondataavailable = handleDataAvailable;
  //     if (!audio) {
  //       mediaRecorder.stop();
  //     }
  //     mediaRecorder.onstop = handleStop;
  //   };
  //   navigator.mediaDevices
  //     .getUserMedia({ audio: true })
  //     .then((stream: MediaStream) => {
  //       initRecorder(stream);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  //   return () => {
  //     if (mediaRecorder && mediaRecorder.state !== "inactive") {
  //       mediaRecorder.stop();
  //     }
  //   };
  // }, [audio, data]);

  useEffect(() => {
    if (searchBarData) {
      setData({ ...searchBarData });
    }
  }, [searchBarData]);
  console.log('dropDownData34534', dropDownData);

  return (
    <Box padding={'20px'} className="filter-cells-container scrollbar-hide">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} lg={10} xl={10} md={10}>
          {/* <Box className={classes.searchContainer} sx={{ width: { xs: '100vw', sm: '100vw', md: '100%', lg: '100%', xl: '100%' }, height: '36px' }}>
            {dropDownData && handleDropDownChange && (
              <KenSelect
                options={dropDownData.map((location) => ({
                  value: location, // Map locations to { value, label } format
                  label: location,
                }))}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  console.log('eehgfghh', e.target, e.target.value);

                  if (e.target && e.target.value !== '') {
                    handleDropDownChange(e.target.value);
                  }
                }}
                value={data?.dropDown || ''}
                InputProps={{
                  className: jobClasses.inputStyles,
                  startAdornment: (
                    <InputAdornment position="start" className="hellp kasn">
                      <LocationOnOutlinedIcon sx={{ height: { xs: '14px', sm: '18px', md: '20px' } }} />
                    </InputAdornment>
                  ),
                }}
              />
              // <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Choose Option">
              //   <MenuItem value="">
              //     <em>None</em>
              //   </MenuItem>
              //   <MenuItem value="option1">Option 1</MenuItem>
              //   <MenuItem value="option2">Option 2</MenuItem>
              //   <MenuItem value="option3">Option 3</MenuItem>
              // </Select>
            )}
            <Divider orientation="vertical" />
            <KenInput
              placeholder="Search by company or job"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target) {
                  console.log('e.target', e.target, e.target.value);
                  handleSearchChange(e.target.value);
                }
              }}
              value={data?.input || ''}
              InputProps={{
                className: jobClasses.inputStyles,
                // startAdornment: (
                //   <InputAdornment position="end">
                //     <MicIcon style={{ height: "20px" }} />
                //   </InputAdornment>
                // ),
              }}
            />
          </Box> */}
          <Box sx={{ height: '36px', width: '100%' }} display={'flex'} justifyContent={'start'}>
            <Box sx={{ display: 'flex', alignItems: 'center', border: '1px solid #B2B3B7', borderRadius: '6px 0px 0px 6px', width: '15vw' }}>
              <InputAdornment position="start">
                <LocationOnOutlinedIcon style={{ fontSize: '18px', marginLeft: '10px' }} />
              </InputAdornment>
              {dropDownData && handleDropDownChange && (
                <Select
                  labelId="custom-select-label"
                  value={data?.dropDown || ''}
                  onChange={(event: SelectChangeEvent<string>) => {
                    const value = event.target.value;
                    console.log('Selected value:', value);

                    if (value !== '') {
                      handleDropDownChange(value);
                    }
                  }}
                  sx={{
                    height: '36px',
                    fontSize: '12px',
                    borderRadius: '6px 0px 0px 6px',
                    width: '100%',
                    border: 'none',
                    outline: 'none',
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#3061FF', 
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      border: 'none',
                    },
                    '&:hover': {
                      border: 'none',
                    },
                    '&.Mui-focused': {
                      border: 'none',
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        '& .MuiMenuItem-root': {
                          fontSize: '12px',
                        },
                      },
                    },
                  }}
                >
                  {dropDownData.map((location: any) => {
                    return <MenuItem value={location}>{location}</MenuItem>;
                  })}
                </Select>
              )}
            </Box>
            <TextField
              placeholder="Search by company or job"
              variant="outlined"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target) {
                  console.log('e.target', e.target, e.target.value);
                  handleSearchChange(e.target.value);
                }
              }}
              value={data?.input || ''}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <MicIcon style={{ fontSize: '18px' }} />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: {
                  height: '36px',
                  borderRadius: '0px 6px 6px 0px',
                },
              }}
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '0px 6px 6px 0px',
                  height: '36px',
                  fontSize: '12px',
                },
                '& .MuiInputBase-input::placeholder': {
                  fontSize: '12px',
                },
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} lg={2} xl={2} md={2} sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button
            style={{ textTransform: 'capitalize', height: '36px' }}
            size="small"
            onClick={() => {
              handleFilter();
            }}
            variant="contained"
            startIcon={<FilterAltOutlinedIcon sx={{ fontSize: '14px', color: KenColors.ClientBlack2 }} />}
            className={jobClasses.filterBtn}
          >
            <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Filters</Typography>
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SearchBar;
